// src/context/loaderSingleton.ts
type LoaderSetter = (loading: boolean) => void;

export const loader = {
  setLoading: (_val: boolean) => {},
};

export const registerLoaderSetter = (setter: LoaderSetter) => {
  loader.setLoading = setter;
};
